// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Sessions.proto

/* eslint-disable */
import Long from "long";
import type { CallContext, CallOptions } from "nice-grpc-common";
import {
  ClaimSessionRequest,
  ClaimSessionResponse,
  CloseSessionRequest,
  CloseSessionResponse,
  ConnectRequest,
  ConnectResponse,
  CreateSessionRequest,
  CreateSessionResponse,
} from "./Models/SessionModels";

export const protobufPackage = "daisi.protos.v1";

export type SessionsProtoDefinition = typeof SessionsProtoDefinition;
export const SessionsProtoDefinition = {
  name: "SessionsProto",
  fullName: "daisi.protos.v1.SessionsProto",
  methods: {
    create: {
      name: "Create",
      requestType: CreateSessionRequest,
      requestStream: false,
      responseType: CreateSessionResponse,
      responseStream: false,
      options: {},
    },
    claim: {
      name: "Claim",
      requestType: ClaimSessionRequest,
      requestStream: false,
      responseType: ClaimSessionResponse,
      responseStream: false,
      options: {},
    },
    close: {
      name: "Close",
      requestType: CloseSessionRequest,
      requestStream: false,
      responseType: CloseSessionResponse,
      responseStream: false,
      options: {},
    },
    connect: {
      name: "Connect",
      requestType: ConnectRequest,
      requestStream: false,
      responseType: ConnectResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface SessionsProtoServiceImplementation<CallContextExt = {}> {
  create(
    request: CreateSessionRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CreateSessionResponse>>;
  claim(
    request: ClaimSessionRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<ClaimSessionResponse>>;
  close(
    request: CloseSessionRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CloseSessionResponse>>;
  connect(request: ConnectRequest, context: CallContext & CallContextExt): Promise<DeepPartial<ConnectResponse>>;
}

export interface SessionsProtoClient<CallOptionsExt = {}> {
  create(
    request: DeepPartial<CreateSessionRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CreateSessionResponse>;
  claim(
    request: DeepPartial<ClaimSessionRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<ClaimSessionResponse>;
  close(
    request: DeepPartial<CloseSessionRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CloseSessionResponse>;
  connect(request: DeepPartial<ConnectRequest>, options?: CallOptions & CallOptionsExt): Promise<ConnectResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
